import React,{useEffect, useState} from 'react'
import { UserContext } from '../App'

function Home() {
  const [username, setUsername] = useState('')
  const [show, setShow] = useState(false)
  
  const callHomePage = async () =>{
    
    try {
      const res = await fetch('/getdata',{
      method:"GET",
      headers:{
        "Content-Type":"application/json"
      },
    });
    const data = await res.json();
    console.log(data);
    setUsername(data.name);
    setShow(true);
  } catch (error) {
    console.log(error);
  }
  
}

useEffect(() => {
  callHomePage();
}, [])

  return (
    <>

      <section className='homepage ' style={{background: "linear-gradient(90deg, aliceblue 50%, #E0E0E0 50%)"}}>
        <div style={{minHeight:"100vh"}} className='container d-flex flex-column justify-content-center align-items-center'>
            <h3 className='text-uppercase text-center text-primary'>Welcome</h3>
            <h1 className='text-center'>{username}</h1>
            <h1 className='text-center'>{show ? 'Happy To See You Back':'We Are Modern Developers'}</h1>
        </div>
      </section>
    </>
  )
}

export default Home